document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.about-card');

    cards.forEach((card) => {
        // La lightbox est le frère suivant de la carte dans le DOM
        const lightbox = card.nextElementSibling;
        if (!lightbox || !lightbox.classList.contains('about-lightbox')) return;

        const overlay = lightbox.querySelector('.about-lightbox__overlay');
        const closeBtn = lightbox.querySelector('.about-lightbox__close');

        const openLightbox = () => {
            lightbox.removeAttribute('hidden');
            lightbox.classList.add('is-open');
            document.body.style.overflow = 'hidden';
        };

        const closeLightbox = () => {
            lightbox.setAttribute('hidden', '');
            lightbox.classList.remove('is-open');
            document.body.style.overflow = '';
        };

        // Ouvrir via clic sur la carte ou le bouton +
        card.addEventListener('click', openLightbox);

        // Fermer via overlay ou bouton -
        overlay.addEventListener('click', closeLightbox);
        closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            closeLightbox();
        });

        // Fermer via Échap
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closeLightbox();
        });
    });
});